import { useState } from 'react';

import { Flex } from '@chakra-ui/react';
import { Button, Menu, MenuItem } from '@material-ui/core';
import { useParsedCohortQueryParam } from 'components/hooks/useParsedCohortQueryParam';
import { useSidebarNavMatchRoute } from 'components/hooks/useSidebarNavMatchRoute';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  resetViewsPanel,
  setIsSaveViewModalOpen,
  setViewAction,
  setViewsSubScreen,
  setViewWithSelectedView,
  useViewsPanelState,
  VIEWS_ACTIONS,
  VIEWS_SUB_SCREENS,
} from 'reducers/viewsSlice';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';
// import styled from '@emotion/styled';
import styled from 'styled-components';

import { Clone1, Delete, Ellipsis, OutlineEye, Pen } from 'assets/assetsV1/iconComponents';

import {
  sendApplyViewEvent,
  sendViewsMenuDeleteClicked,
  sendViewsMenuCloneClicked,
  sendViewsMenuEditClicked,
} from 'constants/mixpanelHelpers/viewsEvents';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { applyFilters } from '../Hooks/dataHooks';
import { useViewPageName } from '../Hooks/useViewPageName';

const StyledMenu = styled(Menu)`
  ul {
    padding: 8px;
  }
  & .MuiMenu-paper {
    box-shadow:
      2px 0px 4px 3px rgba(0, 0, 0, 0.12),
      0px 4px 4px 3px rgba(0, 0, 0, 0.08);
    margin-top: 48px;
  }
`;

const StyledMenuItem = styled(MenuItem)`
  padding: 8px 16px 8px 6px;
  border-radius: 4px;
  font-family: inherit;
  &:hover {
    color: #104f95;
    background-color: #e6f1fd;
    svg {
      color: #104f95;
    }
  }
`;

export const ManageViewsMenu = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { module } = useSidebarNavMatchRoute();
  const viewPage = useViewPageName();
  const queryParamsCohort = useParsedCohortQueryParam();
  const { constraints = {} } = useViewsPanelState();

  const loggedInUserId = useSelector(selectLoggedInEmployeeId);

  const isEditAllowed = loggedInUserId === props.data.employee?.uuid;
  const isApplyAllowed = !constraints?.disableApply;
  const isDeleteAllowed = loggedInUserId === props.data.employee?.uuid;

  const handleClick = (event) => {
    event.preventDefault();
    props.setViewSelectedInMenu(props.data.id);
    // if (anchorEl !== event.currentTarget) {
    setAnchorEl(event.currentTarget);
    // }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    dispatch(setIsSaveViewModalOpen(true));
    handleClose();
    sendViewsMenuDeleteClicked({
      eventProperties: {
        source: module,
        page: viewPage,
        viewName: props.data.name,
        viewId: props.data.id,
      },
    });
  };

  const handleApply = () => {
    const view = { id: props.data.id, name: props.data.name, type: props.data.type };
    applyFilters({ history, location, view, module, dispatch, queryParamsCohort });

    // dispatch(setSelectedView(view));
    sendApplyViewEvent({
      eventProperties: {
        source: module,
        page: viewPage,
        viewName: props.data.name,
        viewId: props.data.id,
        clickFrom: 'ManageViews',
      },
    });
    handleClose();
    dispatch(resetViewsPanel());
  };

  const handleEdit = () => {
    dispatch(setViewAction(VIEWS_ACTIONS.EDIT));
    dispatch(setViewWithSelectedView(props.data));
    sendViewsMenuEditClicked({
      eventProperties: {
        source: module,
        page: viewPage,
        viewName: props.data.name,
        viewId: props.data.id,
      },
    });
  };

  const handleClone = () => {
    const newName = `${props.data.name} (Copy)`;
    dispatch(setViewAction(VIEWS_ACTIONS.CLONE));
    dispatch(setViewWithSelectedView({ ...props.data, name: newName }));
    dispatch(setViewsSubScreen(VIEWS_SUB_SCREENS.SAVE));
    sendViewsMenuCloneClicked({
      eventProperties: {
        source: module,
        page: viewPage,
        viewName: props.data.name,
        viewId: props.data.id,
      },
    });
  };

  return (
    <Flex height="100%" alignItems="center" justifyContent="center">
      <Button
        aria-controls={open ? 'simple-views-manage-menu' : undefined}
        aria-haspopup="true"
        disableRipple="true"
        aria-expanded={open ? 'true' : undefined}
        style={{ backgroundColor: anchorEl ? '#e6f1fd' : null, minWidth: 'unset' }}
        onClick={handleClick}
      >
        <Ellipsis boxSize="24px" />
      </Button>
      <StyledMenu
        // disablePortal
        id="simple-views-manage-menu"
        anchorEl={anchorEl}
        // keepMounted
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        style={{
          zIndex: 1400,
        }}
        open={open}
        onClose={handleClose}
        // MenuListProps={{ onMouseLeave: handleClose }}
      >
        {isApplyAllowed && (
          <StyledMenuItem onClick={handleApply}>
            <MenuItemComp Icon={OutlineEye} label="Apply" />
          </StyledMenuItem>
        )}

        {isEditAllowed && (
          <StyledMenuItem onClick={handleEdit}>
            <MenuItemComp Icon={Pen} label="Edit" />
          </StyledMenuItem>
        )}
        {/* <StyledMenuItem>
          <MenuItemComp Icon={EditNote} label="Rename" />
        </StyledMenuItem> */}
        <StyledMenuItem onClick={handleClone}>
          <MenuItemComp Icon={Clone1} label="Clone" />
        </StyledMenuItem>
        {isDeleteAllowed && (
          <StyledMenuItem onClick={handleDelete}>
            <MenuItemComp Icon={Delete} label="Delete" />
          </StyledMenuItem>
        )}
      </StyledMenu>
    </Flex>
  );
};

const MenuItemComp = ({ Icon, label }) => (
  <Flex>
    <Icon boxSize="20px" color="icon.g2" />
    <TextBodyMedium ml={2}>{label}</TextBodyMedium>
  </Flex>
);
